import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCheckPublishModel,
  ICheckPublishRequest,
  IMappers,
  ICheckPublishResponse,
  ICheckPublishResponseError,
  TCheckPublishResponse,
} from './types';

const defaultConfig: TCheckPublishModel = {
  apiType: 'legacy',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'monolith-python',
  pathApi: '/cian-api/site/v1/check-publish/',
  hostType: 'api',
} as TCheckPublishModel;

function createCheckPublishModel(parameters: ICheckPublishRequest): TCheckPublishModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICheckPublishOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICheckPublishRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCheckPublish<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICheckPublishOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TCheckPublishResponse> {
  const { response, statusCode } = await httpApi.fetch(createCheckPublishModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICheckPublishResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICheckPublishResponseError);
    }
  }

  return { response, statusCode } as TCheckPublishResponse;
}

export { defaultConfig, createCheckPublishModel, fetchCheckPublish };
